import script from "./CompareRevisionsDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompareRevisionsDialog.vue?vue&type=script&setup=true&lang=ts"

import "./CompareRevisionsDialog.vue?vue&type=style&index=0&id=44a6f0c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44a6f0c4"]])

export default __exports__